import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

// Global routes
export const globalIntegrationDetailRoute: InvariantJiraRoute = {
	name: 'eoc-integration-detail',
	path: '/jira/settings/products/ops/integrations/:type/:integrationId',
	exact: true,
};
